import { EventEmitter, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as mapboxgl from 'mapbox-gl';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class MapBoxService {
  mapbox = (mapboxgl as typeof mapboxgl);
  map: mapboxgl.Map;
  style = `mapbox://styles/mapbox/streets-v11`;
  // Coordenadas de la localización donde queremos centrar el mapa
  lat = 43.1746;
  lng = -2.4125;
  tokenMapbox = environment.mapBoxToken;
  zoom = 15;
  marker: mapboxgl.Marker;
  emitPosition = new EventEmitter();

  constructor(private http: HttpClient) {
    this.mapbox.accessToken = this.tokenMapbox;
    this.getPosition();
    
  }

  buildMap(container) {
    this.map = new mapboxgl.Map({
      container,
      style: this.style,
      zoom: this.zoom,
      center: [this.lng, this.lat]
    });
    this.map.repaint = true;
    this.map.stop();
    this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    this.map.addControl(new mapboxgl.GeolocateControl(), 'bottom-right');
    this.marker = new mapboxgl.Marker({
      color: "#F00",
      draggable: true
    }).setLngLat([this.lng, this.lat]).addTo(this.map);

    this.map.on('click', (target) => {
      target.lngLat;
      console.log(target.lngLat);
      
      this.marker.setLngLat(target.lngLat);
      this.emitPosition.emit(target.lngLat);
    })
  }

  setCenter(location){
    if(location.id.includes('country')){
      this.map.zoomTo(3, { animate: true, duration: 400 })
      // this.map.setZoom(5)
    }else{
      this.map.setCenter(location.center);
    }
    this.marker.setLngLat(location.center);
  }

  getPosition() {
    return new Promise<any[]>((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resp => {
        this.lng = resp.coords.longitude;
        this.lat = resp.coords.latitude;
        resolve([this.lng, this.lat]);
      }, err => {
        reject(false)
      });
    })
  }

  setSearch(searchText){
    return new Promise((resolve) => {
      this.http.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${searchText}.json?access_token=${this.tokenMapbox}`).subscribe(res => {
        resolve(res);
      });
    })
  }
}
